import axios from "axios";

const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8080"
).trim();

if (
  process.env.NODE_ENV === "production" &&
  (!process.env.REACT_APP_API_BASE_URL ||
    /localhost|127\.0\.0\.1/i.test(API_BASE_URL))
) {
  console.error(
    "[config] Production build should set REACT_APP_API_BASE_URL to your API origin (e.g. https://api.example.com), not localhost."
  );
}

const API_URL = `${API_BASE_URL}/api/`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export const BASE_URL = API_BASE_URL;

export async function refreshSessionCookies() {
  try {
    const refreshResponse = await fetch(
      `${API_BASE_URL}/auth/refresh-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({}),
      }
    );
    return refreshResponse.ok;
  } catch {
    return false;
  }
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;

    if (status === 403) {
      return Promise.reject(error);
    }

    if (status === 401) {
      if (error.config && !error.config._retry) {
        const refreshed = await refreshSessionCookies();
        if (refreshed) {
          error.config._retry = true;
          delete error.config.headers.Authorization;
          return api(error.config);
        }
      }

      sessionStorage.removeItem("returnUrl");

      if (window.location.pathname !== "/auth") {
        window.location.href = "/auth";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
